import { faPowerOff, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field, Formik } from 'formik';
import React, { FC, ReactNode, useEffect, useState} from "react";
import { MONITORING_COMMAND, MONITORING_COMMAND_STATE } from '../../constants/command-status';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useIcaWebsocketContext } from "../../contexts/websocket/IcaWebsocketContext";
import hardwareIcon from '../../images/Hardware.svg';
import { getSites } from '../../services/siteService';
import AvatarMenu from "../avatar-menu/avatar-menu";
import Footer from "../footer/footer";
import HelpTopicsModal from "../help-topics-modal/help-topics-modal";
import Menu from '../item-content-two/site-list';
import EngineStatusModal from "../status/engine-status/engine-status-modal";
import { useSelector } from 'react-redux';
import { IAppState } from '../../store/types';
import { ROLES } from '../../constants/preset-constants';
import ControlPanel from '../dashboard/control-panel/control-panel';
import { useLocation } from 'react-router-dom';

type Props = {
    left?: ReactNode;
    right?: ReactNode;
};

const MenuLayout: FC<Props> = ({ left, right}) => {
    const { translate } = useLocale();
    const icaWebSocket = useIcaWebsocketContext();
    const TYPES = { HELP: 1, ENGINE_STATUS: 2 }
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [showEngineStateModal, setShowEngineStateModal] = useState(false);
    const user = useSelector((state: IAppState) => (state.userInfo));
    const {pathname} = useLocation();

    const showModal = (type) => {
        setShowHelpModal(type == TYPES.HELP);
        setShowEngineStateModal(type == TYPES.ENGINE_STATUS);
    }

    useEffect(() => {
        if (icaWebSocket.connectionState) {
            icaWebSocket.startStopTopic(MONITORING_COMMAND.MONITORING_ENGINE, MONITORING_COMMAND.MONITORING, MONITORING_COMMAND_STATE.MONITORING_START);
            /**
                * MenuLayout is not a page component and it's a global component which is always rendered.
                * So, we don't need to set the websocket onMessage event here as this will swallow all the websocket messages.
                * The logic of handling menu layout related messages is on wesocket context provider.
             */
        }
    }, [icaWebSocket.connectionState])

    return <Formik
        initialValues={{ siteId: '' }}
        onSubmit={fields => { }}>
        <div className="menu-layout flex flex-row w-full h-full">
            <div>{left}</div>
            <div className="flex flex-col w-full overflow-y-hidden bg-darker">
                <div className="navbar w-full bg-white flex flex-row justify-between">
                    <Field
                        name="siteId"
                        fieldName="siteId"
                        component={Menu}
                        fetchData={getSites}/>
                    <div className='flex flex-row'>
                        {/* <LanguageDropdown /> */}
                        <AvatarMenu />
                    </div>
                </div>
                {showHelpModal ? <HelpTopicsModal setShowHelpModal={setShowHelpModal} /> : null}
                {showEngineStateModal ? <EngineStatusModal setShowModal={setShowEngineStateModal} /> : null} 
                
                <div className="flex flex-row flex-grow justify-between overflow-hidden">
                    <div className="flex flex-col flex-grow overflow-hidden relative">
                        {right}
                    </div>{" "}
                    <div className="mt-12 pt-2 ml-4 flex flex-col flex-shrink-0">
                        {" "}
                        <button title={translate.byKey(TranslationKeys.helpTopics)} className="statusBarItem" onClick={() => showModal(TYPES.HELP)} id='helpIcon'>
                            <FontAwesomeIcon style={{ color: 'rgb(210,34,42)', height: '2rem', marginTop: '5px' }} className='faIcon' icon={faQuestionCircle} />
                        </button>
                        {user.profileId === ROLES.ID_SYSTEM_OWNER || user.profileId === ROLES.ID_SITE_ADMIN ?
                            <button title={translate.byKey(TranslationKeys.engineStatus)} style={{ padding: '12px' }} className="statusBarItemWithBadge" onClick={() => showModal(TYPES.ENGINE_STATUS)} id='engineStatusButton'>
                                <img style={{ color: 'grey' }} className="statusBarBtn" src={hardwareIcon} alt="" />
                                <div className="statusBarBadgeIcon" style={{ width: '26px', backgroundColor: (icaWebSocket.engineState.isStarted ? '#99BB32' : 'rgb(210, 34, 42)') }}>
                                    <FontAwesomeIcon style={{ height: '1rem' }} className='faIcon' icon={faPowerOff} />
                                </div>
                            </button> : null
                        } 

                        {pathname === '/access-control/monitoring/dashboard' &&  <ControlPanel/> }
                    </div>
                </div>

                <Footer className="z-10" />
            </div>
        </div>
    </Formik>
};

export default MenuLayout;
